import { Injectable } from '@angular/core';
import { BaseSearchStrategy } from './base-strategy';
import { SearchableItem } from '../models/searchable-item.model';
import {
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';

/**
 * Bonus scoring for hits on German compound word parts.
 * Example: query "arbeitszeit" splits into ["arbeit","zeit"]; items
 * containing either part get a boost. Useful where Settings/Permissions
 * titles use either the compound or its parts.
 */
@Injectable({ providedIn: 'root' })
export class CompoundSplitStrategy extends BaseSearchStrategy {
  readonly id: StrategyId = 'compound-split';
  readonly defaultWeight = 40; // per matched compound part
  private readonly cap = 120;

  override score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null {
    if (ctx.compoundParts.length === 0) return null;
    const haystack = `${this.normalizedTitle(item)} ${this.normalizedDescription(item)} ${this.normalizedKeywords(item).join(' ')}`;
    let hits = 0;
    let evidence: string | undefined;
    for (const part of ctx.compoundParts) {
      if (part.length < 3) continue;
      if (haystack.includes(part)) {
        hits++;
        if (!evidence) evidence = part;
      }
    }
    if (hits === 0) return null;
    return this.match(this.id, Math.min(hits * this.defaultWeight, this.cap), evidence);
  }
}
